import { useEffect, useState } from 'react';
import { api, resolveMediaUrl } from '../../apis/api';
import fallbackImg from '../../asstes/logo.png';
import './projectnamecoursel.css';

function productImgSrc(src) {
  return resolveMediaUrl(src) || fallbackImg;
}

function handleImgError(e) {
  if (e.currentTarget.src !== fallbackImg) {
    e.currentTarget.src = fallbackImg;
  }
}

export const Projectnamecoursel = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.getProducts();
        if (cancelled) return;
        const list = (res.data || []).map((p) => ({
          id: p.product_id,
          name: p.product_name,
          image: p.product_image,
        }));
        setProducts(list);
      } catch (_) {
        if (!cancelled) setProducts([]);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!products.length) return null;

  // Duplicate for seamless infinite loop
  const items = [...products, ...products];

  return (
    <section className="pnc">
      <p className="pnc__label">OUR PRODUCTS</p>
      <div className="pnc__track-wrapper">
        <div className="pnc__track">
          {items.map((product, i) => (
            <div className="pnc__item" key={`${product.id}-${i}`}>
              <img
                className="pnc__img"
                src={productImgSrc(product.image)}
                alt={product.name}
                loading="lazy"
                onError={handleImgError}
              />
              <span className="pnc__name">{product.name}</span>
              <span className="pnc__dot">✦</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
